import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, typography} from "src/main.style";

export const LoginStyle = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        position: 'relative',

        '& > *': {
            boxSizing: "border-box",
        },
    },
    background: {
        position: 'absolute',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        zIndex: -1,
        backgroundColor: theme.palette.background.default,
    },
    backgroundImgCornerTopRight: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    circle: {
        zIndex: 0,
        position: 'absolute',
        top: '-17.125rem',
        left: '-30.75rem',
        width: '56.25rem',
        height: '56.25rem',
        borderRadius: '56.25rem',
        backgroundColor: beigeColor,

        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    container: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(6.5),
    },
    languageSelect: {
        position: 'absolute',
        top: theme.spacing(6.5),
        right: theme.spacing(6.5),
        zIndex: 3,
    },
    topBar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2.5),
    },
    backButton: {
        padding: theme.spacing(1.25, 0),
        textTransform: 'uppercase',
    },
    topContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
    },
    centerContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
        marginTop: theme.spacing(2.5),
    },
    formMiddleContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
    },
    formBottomContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    label: {
        ...typography.label,
    },
    errorMessage: {
        ...typography.feedback,
        color: theme.palette.error.main,
    },
    forgotPasswordLink: {
        color: theme.palette.common.black,
        textDecoration: 'underline',
    },
    footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2.5),
    },
});



// WEBPACK FOOTER //
// ./src/components/login/login.style.ts